import Layout from '@/layout/index.vue'
import Home from '@/views/home/index.vue'
import LifeAtHilton from '@/views/lifeAtHilton/index.vue'
import Benefits from '@/views/benefits/index.vue'
import searchJob from '@/views/searchJob/index.vue'
import searchJobResult from '@/views/searchJob/searchJobResult.vue'
import Loading from '@/views/loading/index.vue'
const routes = [
    { 
        path: '/', 
        component: Layout,
        redirect: '/home',
        children: [
            {
                path: 'home',
                name: "Home",
                component: Home,
                meta: {
                    theme: '',
                    showNavBar: true,
                    showFooter: true,
                    showTabBar: true,
                }
            },
            {
                path: 'lifeAtHilton',
                home: "lifeAtHilton",
                component: LifeAtHilton,
                meta: {
                    theme: '',
                    showNavBar: true,
                    showFooter: true,
                    showTabBar: true,
                }
            },
            {
                path: 'benefits',
                home: "Benefits",
                component: Benefits,
                meta: {
                    theme: '',
                    showNavBar: true,
                    showFooter: true,
                    showTabBar: true,
                }
            },
            {
                path: 'searchJob',
                name: 'SearchJob',
                component: searchJob,
                meta: {
                    theme: 'dark',
                    showNavBar: true,
                    showTabBar: true,
                }
            },
            {
                path: 'searchJobResult',
                component: searchJobResult,
                meta: {
                    theme: 'dark'
                }
            },
            
        ]
    },
    {
        path: "/loading",
        component: Loading,
    }
]
export  default routes